import { render } from "./signfrompopup.vue?vue&type=template&id=ce9d39e4&scoped=true"
import script from "./signfrompopup.js?vue&type=script&lang=js"
export * from "./signfrompopup.js?vue&type=script&lang=js"

import "./signfrompopup.vue?vue&type=style&index=0&id=ce9d39e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce9d39e4"]])

export default __exports__